class StoreLocatorAm extends HTMLElement {
  constructor() {
    super();
    this.sheetUrl = `https://brand.orientelectric.com/api/getSheetUrl`;
    this.sheetDataLocal=[];
    this.categoryMap = new Map();
    this.debounceClear;
    this.category = this.querySelector("#new-slcatid");
    this.state = this.querySelector("#new-slstate");
    this.city = this.querySelector("#new-slcity");
    this.noFoundMessage = this.querySelector("#no-found");
    this.storeLocation = this.querySelector(".store-location-details-new");
    this.querySelector("#goSubmitButton").addEventListener(
      "click",
      this.updateData.bind(this)
    );

    if (this.category.value == "") {
      this.state.innerHTML = `<option value="">Select State</option>`;
    }
    if (this.state.value == "") {
      this.city.innerHTML = `<option value="">Select City</option>`;
    }

    this.category.addEventListener("input", (e) => {
      document.getElementById("section-loader-new").style.display = "block";
      document.querySelector("body").style.overflow = "hidden";
      this.state.innerHTML = `<option value="">Select State</option>`;
      this.city.innerHTML = `<option value="">Select City</option>`;
      this.noFoundMessage?.classList.add("hidden");
      this.storeLocation?.classList.add("hidden");
      this.updateState(e.target.value);
      this.debounce();
    });

    this.state.addEventListener("input", (e) => {
      document.getElementById("section-loader-new").style.display = "block";
      document.querySelector("body").style.overflow = "hidden";
      this.city.innerHTML = `<option value="">Select City</option>`;
      this.noFoundMessage?.classList.add("hidden");
      this.storeLocation?.classList.add("hidden");
      this.updateCity(e.target.value, this.category.value);
      this.debounce();
    });

    this.city.addEventListener("input", () => {
      document.getElementById("section-loader-new").style.display = "block";
      document.querySelector("body").style.overflow = "hidden";
      this.noFoundMessage?.classList.add("hidden");
      this.storeLocation?.classList.add("hidden");
      this.debounce();
    });
    this.sheetData();
  }

  debounce() {
    clearTimeout(this.debounceClear);
    this.debounceClear = setTimeout(() => {
      document.getElementById("section-loader-new").style.display = "none";
      document.querySelector("body").style.overflow = "initial";
    }, 300);
  }

async fetchSheetUrl() {
  try {
    const sheetResponse =  await fetch(this.sheetUrl);
    const data = await sheetResponse.json();
    return data?.data;
  } catch (error) {
    console.error("Error while fetching sheet URL:", error);
    return null;
  }
}

  //! Sheet data fetch call
  async sheetData() {
    document.getElementById("section-loader-new").style.display = "block";
    document.querySelector("body").style.overflow = "hidden";
    const URL = await this.fetchSheetUrl()
    if(!URL) return;

    fetch(URL)
      .then((resp) => resp.json())
      .then((res) => {
         //* Using settimeout for debouncing
        this.debounce();
        this.updateSelectBox(res.values);
      })
      .catch((err) => console.log(err));
  }

  //! function is used to update category select box
  updateSelectBox(data) {
    // console.log(data);
    this.sheetDataLocal = data;
    const storeData = data;
    //* Using map to store store's data along with category
    this.categoryMap = new Map();
    for (let index = 1; index < storeData.length; index++) {
      if (this.categoryMap.has(storeData[index][1])) {
        const dataMap = this.categoryMap.get(storeData[index][1]);
        dataMap.push({
          state: `${
            storeData[index][3] ? storeData[index][3].toUpperCase() : ""
          }`,
          city: storeData[index][4],
          name: storeData[index][2],
          address: storeData[index][8],
          phone: storeData[index][10],
          priority: Number(storeData[index][19]) || 0
        });
        this.categoryMap.set(storeData[index][1], dataMap);
      } else {
        this.categoryMap.set(storeData[index][1], [
          {
            state: `${
              storeData[index][3] ? storeData[index][3].toUpperCase() : ""
            }`,
            city: storeData[index][4],
            name: storeData[index][2],
            address: storeData[index][8],
            phone: storeData[index][10],
            priority: Number(storeData[index][19]) || 0
          },
        ]);
      }
    }
    let innerCat = '<option value="">Select Category</option>';
    for (let [key, values] of this.categoryMap) {
      innerCat += `<option value="${key}">${key}</option>`;
    }
    this.category.innerHTML = innerCat;
  }

  //! Function is used for updating state select field
  updateState(catValue) {
    if (catValue == "") {
      this.state.innerHTML = `<option value="">Select State</option>`;
    } else {
      const storeData = this.sheetDataLocal;
      const myState = new Set();
      for (let index = 1; index < storeData.length; index++) {
        if (catValue == storeData[index][1]) {
          myState.add(storeData[index][3].toUpperCase());
        }
      }
      let innerSt = '<option value="">Select State</option>';
      for (let st of [...myState].sort()) {
        innerSt += `<option value="${st.toUpperCase()}">${st.toUpperCase()}</option>`;
      }
      this.state.innerHTML = innerSt;
    }
  }

  //! Function is used to update city selectbox
  updateCity(stValue, catValue) {
    if (stValue == "") {
      this.city.innerHTML = `<option value="">Select State</option>`;
    } else {
      const storeData = this.sheetDataLocal;
      const myCity = new Map();
      for (let index = 1; index < storeData.length; index++) {
        if (
          catValue == storeData[index][1] &&
          stValue.toUpperCase() == storeData[index][3].toUpperCase()
        ) {
          myCity.set(storeData[index][4], {
            name: storeData[index][2],
            address: storeData[index][8],
            phone: storeData[index][10],
          });
        }
      }
      let innerCt = '<option value="">Select City</option>';
      for (let [ct, more] of myCity) {
        innerCt += `<option value="${ct}"  data-store-name="${more.name}" data-store-address="${more.address}" data-phone=${more.phone}>${ct}</option>`;
      }
      this.city.innerHTML = innerCt;
    }
  }

  //! Function is use to show data on click of search button
  updateData() {
    if (!this.category.value) {
      this.noFoundMessage.innerHTML = "Category not selected";
      this.noFoundMessage?.classList.remove("hidden");
      this.noFoundMessage.scrollIntoView();
      return;
    }
    if (!this.state.value) {
      let eleString = ``;
      // let values = this.categoryMap.get(this.category.value);
      let values = [...this.categoryMap.get(this.category.value)].sort(
        (a, b) => b.priority - a.priority
      );
      for (let i = 0; i < values.length; i++) {
        eleString += this.getHTML(values[i]);
        if (i == 1000) {
          break;
        }
      }
      if (eleString) {
        document.getElementById("addressList").innerHTML = eleString;
        this.storeLocation?.classList.remove("hidden");
        this.noFoundMessage?.classList.add("hidden");
      } else {
        this.storeLocation?.classList.add("hidden");
        this.noFoundMessage?.classList.remove("hidden");
      }
      this.storeLocation.scrollIntoView();
      return;
    } else if (this.city.value && this.state.value && this.category.value) {
      let eleString = ``;
      // let values = this.categoryMap.get(this.category.value);

      // for (let i = 0; i < values.length; i++) {
      //   if (
      //     this.state.value == values[i].state &&
      //     this.city.value == values[i].city
      //   ) {
      //     eleString += this.getHTML(values[i]);
      //   }
      // }
      let values = [...this.categoryMap.get(this.category.value)]
        .filter(
          (store) =>
            this.state.value == store.state &&
            this.city.value == store.city
        )
        .sort((a, b) => b.priority - a.priority);

      for (let i = 0; i < values.length; i++) {
        eleString += this.getHTML(values[i]);
      }
      if (eleString) {
        document.getElementById("addressList").innerHTML = eleString;
        this.storeLocation?.classList.remove("hidden");
        this.noFoundMessage?.classList.add("hidden");
      } else {
        this.storeLocation?.classList.add("hidden");
        this.noFoundMessage?.classList.remove("hidden");
      }
      this.storeLocation.scrollIntoView();
      return;
    } else if (this.state.value && this.category.value) {
      let eleString = ``;
      // let values = this.categoryMap.get(this.category.value);
      // for (let i = 0; i < values.length; i++) {
      //   if (this.state.value == values[i].state) {
      //     eleString += this.getHTML(values[i]);
      //   }
      // }
      let values = [...this.categoryMap.get(this.category.value)]
        .filter((store) => this.state.value == store.state)
        .sort((a, b) => b.priority - a.priority);

      for (let i = 0; i < values.length; i++) {
        eleString += this.getHTML(values[i]);
      }
      if (eleString) {
        document.getElementById("addressList").innerHTML = eleString;
        this.storeLocation?.classList.remove("hidden");
        this.noFoundMessage?.classList.add("hidden");
      } else {
        this.storeLocation?.classList.add("hidden");
        this.noFoundMessage?.classList.remove("hidden");
      }
      this.storeLocation.scrollIntoView();
      return;
    }
  }

  //! function is used to get HTML for single data of store
  getHTML(value) {
    return `<li class="address-list--inner">
            <div id="storeName" class="store-name-new store-name">${
              value.name
            }</div>
            <p id="storeAddress" class="store_address store-location info">
              ${value.address}
            </p>
            ${
              value.phone
                ? `<p id="storePhone" class="store_phone phone-no info">
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14">
                  <path id="Path_241969" data-name="Path 241969" d="M339.18,2836.342a2.037,2.037,0,0,1,3.267-.128l.225.272c.659.807,1.318,1.608,1.571,1.856a.753.753,0,0,1,.113.921l-1.387,2.317a5.93,5.93,0,0,0,.364.513,12.57,12.57,0,0,0,1.017,1.14,14.281,14.281,0,0,0,2.033,1.7l2.276-1.366a.751.751,0,0,1,.875.076l2.2,1.856a2.053,2.053,0,0,1-.133,3.238,5.23,5.23,0,0,1-5.787.355,23,23,0,0,1-4.235-3.276,18.788,18.788,0,0,1-2.851-3.676A5.282,5.282,0,0,1,339.18,2836.342Zm2.1.83a.531.531,0,0,0-.872.045,3.787,3.787,0,0,0-.389,4.151,17.431,17.431,0,0,0,2.622,3.381,21.611,21.611,0,0,0,3.954,3.049,3.722,3.722,0,0,0,4.122-.294.54.54,0,0,0,.035-.853l-1.783-1.509-2.205,1.321a.745.745,0,0,1-.761.007,13.858,13.858,0,0,1-2.722-2.174,13.553,13.553,0,0,1-1.141-1.275,5.2,5.2,0,0,1-.737-1.2.76.76,0,0,1,.056-.664l1.313-2.189c-.352-.408-.82-.981-1.253-1.5C341.439,2837.361,341.358,2837.27,341.281,2837.172Z" transform="translate(-337.832 -2835.304)" fill="#000" stroke="#15191d" stroke-width="0.3" fill-rule="evenodd"/>
                </svg>
                <span>${value.phone}</span>
              </p>`
                : ""
            }
            <div id="storeLinksContainer" class="store_links_container">
              <a href="tel:${
                value.phone
              }" class="button button--primary button--animation">
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14">
                  <path id="Path_241969" data-name="Path 241969" d="M339.18,2836.342a2.037,2.037,0,0,1,3.267-.128l.225.272c.659.807,1.318,1.608,1.571,1.856a.753.753,0,0,1,.113.921l-1.387,2.317a5.93,5.93,0,0,0,.364.513,12.57,12.57,0,0,0,1.017,1.14,14.281,14.281,0,0,0,2.033,1.7l2.276-1.366a.751.751,0,0,1,.875.076l2.2,1.856a2.053,2.053,0,0,1-.133,3.238,5.23,5.23,0,0,1-5.787.355,23,23,0,0,1-4.235-3.276,18.788,18.788,0,0,1-2.851-3.676A5.282,5.282,0,0,1,339.18,2836.342Zm2.1.83a.531.531,0,0,0-.872.045,3.787,3.787,0,0,0-.389,4.151,17.431,17.431,0,0,0,2.622,3.381,21.611,21.611,0,0,0,3.954,3.049,3.722,3.722,0,0,0,4.122-.294.54.54,0,0,0,.035-.853l-1.783-1.509-2.205,1.321a.745.745,0,0,1-.761.007,13.858,13.858,0,0,1-2.722-2.174,13.553,13.553,0,0,1-1.141-1.275,5.2,5.2,0,0,1-.737-1.2.76.76,0,0,1,.056-.664l1.313-2.189c-.352-.408-.82-.981-1.253-1.5C341.439,2837.361,341.358,2837.27,341.281,2837.172Z" transform="translate(-337.832 -2835.304)" fill="#fff" stroke="#15191d" stroke-width="0.3" fill-rule="evenodd"/>
                </svg>
                &nbsp;Call Store
              </a>
            </div>
          </li>`;
  }
}

customElements.define("store-locator-am", StoreLocatorAm);
